/**
 * Функция для определения типа страницы на основе пути и данных вкладок
 * @param {string} localPath - путь страницы (например, '/about_us/publication_name')
 * @param {Array} tabs - массив вкладок из Redux
 * @returns {string} - 'tab' или 'publication'
 */
export const detectPageType = (localPath, tabs) => {
  if (!localPath || !tabs || tabs.length === 0) {
    return 'tab';
  }

  // Разбиваем путь на массив
  const pathArray = localPath.split('/').filter((item) => item !== '');

  // Если путь пустой или только '/', это главная страница
  if (pathArray.length === 0) {
    return 'tab';
  }

  // Находим main_tab элемент
  let mainTabElement = null;
  for (let i = 0; i < tabs.length; i++) {
    const element = tabs[i];
    if (element.eng_name === 'main_tab') {
      mainTabElement = element;
      break;
    }
  }

  // Если путь содержит только один элемент
  if (pathArray.length === 1) {
    // Проверяем, является ли это числом (страница пагинации main_tab)
    const isNumber = /^\d+$/.test(pathArray[0]);
    if (isNumber) {
      return 'tab';
    }

    // Проверяем, является ли это вкладкой
    let foundMatch = false;
    for (let i = 0; i < tabs.length; i++) {
      const element = tabs[i];
      if (element.eng_name === pathArray[0]) {
        foundMatch = true;
        break;
      }
    }

    if (foundMatch) {
      return 'tab';
    } else {
      // Если это не вкладка, проверяем, является ли это публикацией главной страницы
      if (mainTabElement && mainTabElement.publications) {
        for (let i = 0; i < mainTabElement.publications.length; i++) {
          const element = mainTabElement.publications[i];
          if (element.eng_name === pathArray[0]) {
            return 'publication';
          }
        }
      }
      return 'tab'; // По умолчанию считаем вкладкой
    }
  }

  // Если путь содержит больше одного элемента
  if (pathArray.length > 1) {
    // Проверяем, является ли первый элемент вкладкой
    let foundMatch = false;
    let matchTab = null;

    for (let i = 0; i < tabs.length; i++) {
      const element = tabs[i];
      if (element.eng_name === pathArray[0]) {
        foundMatch = true;
        matchTab = element;
        break;
      }
    }

    if (foundMatch) {
      // Если путь содержит два элемента и второй - число, это страница пагинации раздела
      const isNumber = /^\d+$/.test(pathArray[1]);
      if (pathArray.length === 2 && isNumber) {
        return 'tab';
      }
      
      // Проверяем, является ли второй элемент публикацией этой вкладки
      if (matchTab && matchTab.publications) {
        for (let i = 0; i < matchTab.publications.length; i++) {
          const element = matchTab.publications[i];
          if (element.eng_name === pathArray[1]) {
            return 'publication';
          }
        }
      }
      return 'tab'; // Если публикация не найдена, считаем вкладкой
    } else {
      return 'tab'; // Если вкладка не найдена, считаем вкладкой
    }
  }

  return 'tab'; // По умолчанию
};

export default detectPageType;
